import server from 'common/utils/server';

export const initialState = {
  teams: [],
  teamsById: {},
  loaded: false,
  isLoading: false,
};

export function teamState(state = initialState, action) {
  switch (action.type) {
    case 'START_LOADING_TEAMS': {
      return { ...state, isLoading: true };
    }
    // adds teams to `teams` -- does not replace
    case 'RECEIVED_TEAMS': {
      const teamsById = { ...state.teamsById };
      const { teams } = action;
      teams.forEach(team => {
        teamsById[team.id] = team;
      });
      return {
        ...state,
        teams: Object.values(teamsById),
        teamsById,
        loaded: true,
        isLoading: false,
      };
    }
    default: {
      return state;
    }
  }
}

export const getAllTeams = rbacProductAreaContext => async (dispatch, getState) => {
  const { teamState } = getState();
  if (teamState.isLoading) return;

  dispatch({ type: 'START_LOADING_TEAMS' });
  const { groups } = await server.get('/api/v1/groups', { product_area: rbacProductAreaContext });
  dispatch({ type: 'RECEIVED_TEAMS', teams: groups });
};
